import { render, staticRenderFns } from "./CardMatches.vue?vue&type=template&id=299a187a"
import script from "./CardMatches.vue?vue&type=script&lang=js"
export * from "./CardMatches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports